import React, {useEffect, useRef} from 'react';
import styled, {css} from 'styled-components';
import {COLORS, ELEVATIONS, SIZES} from '@fupa/fupa-uikit';

const DrawerSC = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 70%;
  max-width: 22.5rem;
  background-color: ${COLORS.white};
  box-shadow: ${ELEVATIONS.Dialog};
  overflow: auto;
  height: 100%;
  position: fixed;
  top: 0;
  outline: 0;
  left: auto;
  right: 0;
  padding-top: env(safe-area-inset-top);
  padding-bottom: 0.5rem;
  z-index: 75;
  will-change: width;
  ${props =>
    props.hide &&
    css`
      width: 0;
      transition: width ${props => props.animationDuration * 2}ms cubic-bezier(0.2, 0, 0, 1) 0s;
      > * {
        opacity: 0;
        visibility: hidden;
        transition: opacity ${props => props.animationDuration}ms linear,
          visibility ${props => props.animationDuration}ms linear;
      }
    `}

  ${props => props.theme.desktopLayout`
    height: auto;
    width: 100%;
    border-radius: ${SIZES['4']};
    top: ${SIZES['48']};
  `}
`;

const Drawer = ({closable, hide, onClose, anchorEl, children, ...props}) => {
  const ref = useRef(null);
  useOutsideClicked(ref, hide, closable, anchorEl, onClose);
  return (
    <DrawerSC ref={ref} {...props}>
      {children}
    </DrawerSC>
  );
};

export {Drawer};

function useOutsideClicked(ref, hide, closable, anchorEl, onClose) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        (!hide && ref.current && !ref.current.contains(event.target)) ||
        (anchorEl && anchorEl.current && anchorEl.current.contains(event.target))
      ) {
        onClose();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
}
